export default __webpack_public_path__ + "static/media/img-1.f5a6cc41.jpg";